<template>
  <form>
    <md-card data-tour="advanced_recording_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>videocam</md-icon>
        </div>
        <h4 class="title">
          Recording Configuration
        </h4>
        <help-link :link="helpLink.link" title="recording"></help-link>
      </md-card-header>
      <md-card-content>
        <loading-spinner
          v-if="loadingFeature"
          title="Recording Config"
        ></loading-spinner>
        <div class="md-layout" v-if="!loadingFeature">
          <div :class="recordingAuthorized == false ? 'feature-disabled' : ''"
          class="md-layout-item md-size-100 md-small-size-100">
            <div class="md-subheading">Recording</div>
            <div class="md-layout md-alignment-center-left">
              <md-switch
                v-model="recordingEnabled"
                v-bind:disabled="recordingAuthorized == false"
                class="md-layout-item md-size-5"
              ></md-switch>
              <div class="md-layout-item">
                Automatically start recording when the Channel is activated
              </div>
            </div>
          </div>
          <div :class="recordingAuthorized == false ? 'feature-disabled' : ''"
          class="md-layout-item md-size-100 md-small-size-100">
            <div class="md-subheading">Muxing</div>
            <div class="md-layout md-alignment-center-left">
              <md-switch
                v-model="muxingEnabled"
                v-bind:disabled="recordingAuthorized == false"
                class="md-layout-item md-size-5"
              >
              </md-switch>
              <div class="md-layout-item">
                Automatically combine multiple individual upstreams for the Channel
              </div>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate, LoadingSpinner} from "@/fmComponents";
import helpLinks from "../../contextualHelpLinks.js";
import validationRules from "../../validationRules";
export default {
  props: {
    channel: null,
    ogChannel: null,
    recordingAuthorized: null,
    headerColor: {
      type: String,
      default: ""
    },
    loadingFeature: {
      type: Boolean,
      default: true
    },
  },
   computed: {
    recordingEnabled: {
      get: function() {
        if (
          this.channel == null ||
          this.channel.recordingEnabled == null ||
          !this.recordingAuthorized
        ) {
          return false;
        }
        return this.channel.recordingEnabled;
      },
      set: function(state) {
        this.channel.recordingEnabled = state;
      }
    },
    muxingEnabled: {
      get: function() {
        if (
          this.channel == null ||
          this.channel.recordingManagementOverride == null ||
          this.channel.recordingManagementOverride.muxDisabled == null ||
          !this.recordingAuthorized
        ) {
          return false;
        }
        return !this.channel.recordingManagementOverride.muxDisabled;
      },
      set: function(state) {
        this.channel.recordingManagementOverride.muxDisabled = !state;
      }
    }
  },
  components: {
    "help-link": HelpLinkTemplate,
    LoadingSpinner,
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.recordingConfig
  }),
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateChannel: function(input) {
      input.$touch();
      if (input.$error) {
        this.$store.commit("pushError", "Positive values are required.");
      }
    }
  },
  validations() {
    return validationRules;
  }
};
</script>
<style lang="scss" scoped>
.feature-disabled {
  color: #bebebe;
}
@media screen and (min-width: 1117px) {
  h4.title {
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>
